import { useCallback, useMemo } from 'react';
import { getGlobalConfig } from '../../global/ConfigProvider';
import { useAxios } from '../../hooks/useAxios';

type Integration = {
  wb_event: any;
  uid: string;
  other_app_name: string;
};

export function usePushToApp(aiId: string | null, activityLabel?: string) {
  const { baseApiUrl } = getGlobalConfig();
  const [integrationResponse] = useAxios({
    url: 'activity/getIntegrations',
  });
  const integrations = useMemo(
    () => integrationResponse?.data?.integrations || [],
    [integrationResponse]
  );

  const label = activityLabel ?? 'Action';

  const zapUpdateUrl = useMemo(() => {
    const url: string = integrationResponse?.data?.zapUpdateUrl ?? '';
    if (url.startsWith(baseApiUrl)) {
      return url.replace(baseApiUrl, '');
    }
    return url;
  }, [integrationResponse, baseApiUrl]);

  const [, postToApp] = useAxios(
    {
      url: zapUpdateUrl,
      method: 'POST',
    },
    { manual: true }
  );

  const pushToApp = useCallback(
    async (integration: Integration) => {
      const {
        wb_event: event,
        uid,
        other_app_name: otherAppName,
      } = integration;
      try {
        await postToApp({
          data: { aid: aiId, event, uid, otherAppName },
        });
        toastr?.success(`${label} sent to ${otherAppName}.`);
      } catch (error) {
        toastr?.error(
          `There was a problem while sending ${label.toLowerCase()} to ${otherAppName}. Please try again later.`
        );
        console.error(error);
      }
    },
    [postToApp, aiId, label]
  );

  return [integrations, pushToApp] as const;
}
